module.exports = __webpack_public_path__ + "static/media/101.4f3a0b4b.jpg";